import React from 'react';
import { Trans } from 'react-i18next';
import { WeezHeader, Button, EmptyCard } from '@weezevent/nacre';
import ImageEmptyCard from '../../images/image_empty_error.png';
import { getMenhirUrl } from '../../utils/config';

export default function Api() {
    const menhirUrl = getMenhirUrl();

    return (
        <div>
            <WeezHeader title={<Trans i18nKey="ticket.api.title" />} />
            <EmptyCard
                title={<Trans i18nKey="empty.title" />}
                subTitle={<Trans i18nKey="empty.subtitle" />}
                image={ImageEmptyCard}
                cta={menhirUrl ? <Button primary label={<Trans i18nKey="empty.cta" />} as="a" href={`${menhirUrl}/bo/utilisateurs.php`} /> : null}
            />
        </div>
    );
}
